export default __webpack_public_path__ + "static/media/refill_1.a84ff08a.wav";